import { render } from "./home-photos.vue?vue&type=template&id=ea24c272"
import script from "./home-photos.js?vue&type=script&lang=js"
export * from "./home-photos.js?vue&type=script&lang=js"

import "./home-photos.vue?vue&type=style&index=0&id=ea24c272&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__